import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";

const onRestaurantUpdate = /* GraphQL */ `
  subscription OnRestaurantUpdate($code: ID!) {
    onRestaurantUpdate(code: $code) {
      code
      event
      timestamp
    }
  }
`;

export const subscribeToRestaurantUpdates = (code, config, onMetadataUpdate) => {
    Amplify.configure({
        API: {
            GraphQL: config
        }
    });

    const amplifyClient = generateClient();

    console.log("Realtime update client configured");

    const sub = amplifyClient.graphql({
        query: onRestaurantUpdate,
        variables: { code }
    }).subscribe({
        next: ({ data }) => {
            console.log("Received metadata update event");

            if (data.onRestaurantUpdate.event === "METADATA.UPDATED") {
                onMetadataUpdate?.();
            }
        },
        error: (err) => console.error("Subscription error:", err),
    });

    return () => sub.unsubscribe();
}